/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanyRoles = 'Purchaser' | 'Vendor' | 'Unknown';

export const CompanyRoles = {
    Purchaser: 'Purchaser' as CompanyRoles,
    Vendor: 'Vendor' as CompanyRoles,
    Unknown: 'Unknown' as CompanyRoles
};

